import type { FC } from "react";

export const ProgressBar: FC<{
  current: number;
  total: number;
  label: string;
}> = ({ current, total, label }) => {
  const percentage = Math.min(100, Math.max(0, (current / total) * 100));

  return (
    <div className="app-fixed-progress -mx-4 sticky top-0 z-10 mb-2 bg-background/95 px-4 pt-1 pb-3 backdrop-blur-sm">
      <div
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-label={label}
        className="h-2.5 overflow-hidden rounded-full bg-muted shadow-inner"
      >
        <div
          className="app-fixed-progress-fill h-full rounded-full bg-brand transition-[width] duration-300 ease-out motion-reduce:transition-none"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
